import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import ComboBox from "@/components/Elements/ComboBox/ComboBox";
import { convertItemWithSlugToOption } from "@/modules/select";

import { COMPONENT_SHAPE } from "./constants";

const ComponentsSelector = ({
  selectedSlugs = [],
  components = [],
  level = 0,
  onSubComponentSelected = () => {},
  readOnly = false,
  ...rest
}) => {
  const { t } = useTranslation();
  const selectedSlug = selectedSlugs[level] || undefined;
  const selectedComponent = components.find(
    ({ slug }) => slug === selectedSlug
  );
  const hasSubComponents = !!selectedComponent?.components?.length;
  const key = `components-selector-${level}`;

  return (
    <>
      <ComboBox
        {...rest}
        className={readOnly ? "app-select-form-preview" : ""}
        key={key}
        data-testid={key}
        allowClear
        style={{ marginBottom: 4 }}
        value={selectedSlug}
        onChange={(value) => onSubComponentSelected(level, value)}
        initialOptions={components.map(convertItemWithSlugToOption)}
      />

      {hasSubComponents && (
        <ComponentsSelector
          {...rest}
          selectedSlugs={selectedSlugs}
          components={selectedComponent.components}
          level={level + 1}
          onSubComponentSelected={onSubComponentSelected}
          readOnly={readOnly}
          placeholder={t("form:components.placeholderSubcomponent")}
        />
      )}
    </>
  );
};

ComponentsSelector.propTypes = {
  selectedSlugs: PropTypes.arrayOf(PropTypes.string).isRequired,
  components: PropTypes.arrayOf(PropTypes.shape(COMPONENT_SHAPE)).isRequired,
  level: PropTypes.number.isRequired,
  onSubComponentSelected: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
};

export default ComponentsSelector;
